import React from 'react';

const Partners = () => {
  const partners = [
    {
      name: "MeitY",
      logo: "https://customer-assets.emergentagent.com/job_access-limbs/artifacts/865wbpya_image.png"
    },
    {
      name: "MeitY Startup Hub",
      logo: "https://customer-assets.emergentagent.com/job_access-limbs/artifacts/7kwzw6gu_image.png"
    },
    {
      name: "MSME",
      logo: "https://customer-assets.emergentagent.com/job_access-limbs/artifacts/1gumhqt6_image.png"
    },
    {
      name: "BITS TBI",
      logo: "https://customer-assets.emergentagent.com/job_access-limbs/artifacts/sh90z6rg_image.png"
    },
    {
      name: "NCPEDP",
      logo: "https://customer-assets.emergentagent.com/job_access-limbs/artifacts/fr8wzcqa_image.png"
    },
    {
      name: "IIT Delhi IHFC",
      logo: "https://customer-assets.emergentagent.com/job_access-limbs/artifacts/g08p06qj_image.png"
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-purple-50 via-blue-50 to-amber-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-2">
            <span className="bg-gradient-to-r from-purple-600 to-blue-500 bg-clip-text text-transparent">
              Supported By
            </span>
          </h2>
          <p className="text-lg text-gray-600">
            Backed by leading institutions and organizations
          </p>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="flex items-center justify-center p-6 rounded-xl bg-white hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="max-h-20 w-auto object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
